import React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from 'src/components'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import styles from './Sending.module.scss'
import { SearchUser } from './components'

const SendingPage = () => {
  const { t } = useTranslation()
  const userId = useGlobalStore((state) => state.user?.id)

  return (
    <>
      <Header variant='action' action='add' path='..' share={String(userId)} />

      <main className={styles.wrapper}>
        <div className={styles.wrapper_header}>
          <h1 className={styles.wrapper_title}>{t('sending_page.title')}</h1>
          <p className={styles.wrapper_subtitle}>{t('sending_page.subtitle')}</p>
        </div>

        <SearchUser />
      </main>
    </>
  )
}

export default SendingPage
